export default {
	en: {
		client: 'Client',
		company: 'Company',
		email: 'Email',
		password: 'Password',
		email2: 'Email or phone',
		logIn: 'Log In',
		logOut: 'Log Out',
		forgotPass: 'Forgot your password?',
		noAccount: "Don't have an account?",
		createAccount: 'Create one here',
		selectLanguage: 'Select Language',
		clientAccount: 'Create Client Account',
		businessAccount: 'Create Business Account',
		allSet: 'I already have an account',
		recoverPass: 'Recover password',
		registration: 'Registration email',
		send: 'Send',
		recordClient: 'Client registration',
		recordCompany: 'Company Registration',
		mandatoryField: 'Mandatory Field',
		nameM: 'Name *',
		phoneM: 'Phone *',
		birthday: 'Birth Date',
		minAge: 'Client must be at least 18 years old',
		emailM: 'Email *',
		passwordM: 'Password *',
		confirmPassM: 'Confirm Password *',
		termsAndConditions: 'Accept terms and conditions -',
		see: 'See',
		acceptConditions: 'Terms and conditions not accepted',
		accountCreated: 'Already have an account?',
		companyNameM: 'Company Name *',
		atentionC: 'Counter or Bar Attention (without waiters)',
		atentionR: 'Restaurant Attention (with waiters)',
		atentionFC: 'Food Center Attention (with waiters)',
		atentionE: 'Event Attention (with waiters)',
		atentionHT: 'Hospitality Attention (with waiters)',
		atentionH: 'Hospital Attention (with waiters)',
		atentionCM: 'Casino Machine Attention (with waiters)',
		atentionG: "Gym Attention (with assistants)",
		atentionO: "Other - Sale of products or services in general  (without assistants)",
		numRooms: 'No. of rooms',
		numMachines: 'Number of machines',
		numStations: 'Number of stations',
		numAssistants: 'Number of waiters',
		anniversary: 'Anniversary',
		ok: 'OK',
		selectMoney: 'Select Currency Unit',
		registrateComp: 'Register Company',
		invalidPass: 'Password does not match',
		invalidPhone: 'Invalid phone: Must contain 10 digits',
		invalidEmail: 'Invalid email: Incorrect format',
		registrate: 'Register',
		cancel: 'Cancel',
		atteType: 'Select the type of care',
		justSeeMenu: 'Just view the menu',
		menu: 'Menu',
		sendToAssistants: 'Send orders to the assistant',
		sendToKitchen: 'Send orders directly to the kitchen',
		accessType: 'Select the type of access for clients',
		close: 'Close',
		terms_condi_ruf: 'Terms and Conditions of Ruf',
		responsability: 'Disclaimer:',
		responsabilityTxt1: `The terms 'we' or 'our' refer to Ruf. Please note that our Terms and Conditions may change without prior notice. By using our site or placing an order, you agree to the terms below. To the extent permitted by law, we disclaim all liability for any inconvenience arising from the use of our site and system.`,
		changes: 'Order Changes:',
		changesTxt1: `If there is any change in your order, we will inform you and proceed to contact the company to issue a refund in case of cancellation. We assume no liability for any damages arising from this practice.`,
		cancelPolitics: 'Cancellation Policy:',
		cancelPoliticsTxt: `If you wish to cancel an order, please notify us immediately. Cancellation is at our discretion and that of the company where you use this platform. If the food has not yet been prepared, we will generally allow cancellation and provide a refund. Once the order has been placed, it cannot be canceled.`,
		alcohol: 'Alcohol Service:',
		alcoholTxt: `We operate as a licensed place for the sale of alcohol and comply with all local laws in this regard. We do not serve alcohol to minors under 18 years of age.`,
		payments: 'Payments:',
		paymentsTxt: `Currently, we do not accept payments, but when we do, they will be processed securely.`,
		taxes: 'Taxes:',
		taxesTxt: `Our prices include taxes, varying by company. The rate is usually 8% in border areas and 16% in inland Mexico.`,
		rights: 'Copyright:',
		rightsTxt: `All images and content on the site are copyrighted and licensed. They must not be distributed, modified, or used without our prior consent, which may be denied at our discretion. The site may be printed but not modified or used for commercial purposes.`,
		webSite: 'Website:',
		webSiteTxt: `By using our website, you agree to our terms and conditions. We strive to ensure the accuracy of the information, but we do not assume responsibility for any damages arising from incorrect information or performance issues. We use third-party content on our site.`,
		privacy: 'Privacy:',
		privacyTxt: `Your privacy is fundamental. We only request information during platform registration or if you attend companies that use our service, the app only shares your information with the companies you visit, but does not share your data with places where our platform is not used, that said, you will have consent about how this application works, you can be sure that we will take care of and protect your information. In cases where registration is done by the company, we will not use your information except to contact you or inform you of important information, but we will not share your information with anyone.`,
		contacts: 'Contacts',
		contact: 'Contact',
		offices: 'Offices',
		support: 'Support',
		sales: 'Sales',
		admin: 'Administration',
		mail: 'Emails',
		webPage: 'Website',
		productSelectedInStationFormScreen: 'The selected product will be displayed by scanning the generated QR code.',
		updateItemsMessage: (entities) => `The ${entities} were successfully updated.`,
		stalls: 'Stalls',
		stall: 'Stall',
		save: 'Save',
		cancel: 'Cancel',
		new: 'New',
		cleanFilters: 'Clean Filters',
		actions: 'Actions',
		order: 'Order',
		name: 'Name',
		phone: 'Phone',
		typeOfClientAccess: 'Type of client access',
		delete: 'Delete',
		typeOfAttention: 'Type of attention',
		placeHolder: (entity) => `Write the ${entity?.toLowerCase()} here.`,
		numAssistant: 'Number of assistants',
		attachLogo: 'Attach logo',
		attachCoverImage: 'Attach cover image',
		attachMapImage: 'Attach map image',
		attachImage: 'Attach image',
		stations: 'Stations',
		import: 'Import',
		code: 'Code',
		edit: 'Edit',
		exportToCSV: 'Export to CSV',
		printQRs: 'Print QR codes',
		importFile: 'Import file',
		importEntity: (entity) => `Import ${entity}`,
		exportFile: 'Export file',
		filterByErrors: 'Filter by errors',
		verify: 'Verify',
		saveTheRecord: 'Please save the record first',
		cannotBeEmpty: `It can't be empty`,
		hideCompanyLabel: 'Hide super company',
		hideCompanyInfo: 'Hide super company in stalls menu',
		parameters: 'Parameters',
		recommendedProduct: 'Recommended product',
		sendNotificationAfter: 'Send notification after... (HH:mm)',
		notificationSettings: 'Notification settings',
		serviceRating: 'Service rating',
		recomendationInfo: 'Recommend the following products every time you buy',
		notifyClient: "Notify the client",
		accessVisible: "Visible Access Menu",
		sendToAssistant: "Send orders to assistant",
		wirelessNetworkName: 'Wireless network name',
		wirelessNetworkPassword: 'Wireless network password',
		downloadQrCode: 'Download QR Code',
		products: 'Products',
		product: 'Product',
		seeProducts: 'See Products',
		companies: 'Companies',
		callAssistant: 'Call Assistant',
		statusOfOrder: 'Status of Order',
		offersAndWallet: 'Offers and Wallet',
		scanQR: 'Scan QR',
		listOfCompatibleCompanies: 'List of Compatible Companies',
		hello: 'Hello',
		guest: 'Guest',
		pressTheButtonToScan: 'Press the button to scan',
		captureCode: 'Capture the QR code',
		search: 'Search',
		searchAndSelectFoodExt: 'Search and select a food extra',
		searchProducts: 'Search products',
		enterTheCode: 'Enter the code',
		companyName: 'Company name',
		stationName: 'Station name',
		rate:"Rate",
		skip:"Skip",
		bad:"Bad",
		notGood:"Not good",
		good:"Good",
		veryGood:" Very good",
		excellemt:"Excellent",
		enableAppPermissions: 'Enable app permissions in Client Settings',
		loginSettings: 'Login Settings',
		hideEmail: 'Hide email',
		notProvided: 'Not provided',
		welcomeTo: 'Welcome to',
		seeMenu: 'See Menu',
		branch_offices: 'Branch Offices',
		reservations: 'Reservations',
		communications: 'Communications',
		watch_orders: 'Watch Orders',
		connect_to_wifi: 'Connect to Wifi',
		security: 'Security',
		usernameLabel: 'Username',
		passwordLabel: 'Password',
		loginButton: 'Login',
		forgotPassword: 'Forgot your password?',
		languagePlaceholder: 'Select a language.',
		spanish: 'Español',
		english: 'English',
		portuguese: 'Português',
		arabic: 'عرب',
		clientButton: 'Client',
		title: 'Ruf: Explore, order and pick it up',
		welcomeText: 'Improving the customer experience',
		descriptionText: 'Vehicle tracking and monitoring',
		description: 'Description',
		mandatory: 'Mandatory',
		selectorType: 'Selector type',
		single: 'Single',
		multiple: 'Multiple',
		quantity: 'Quantity',
		foodExtras: 'Extras',
		foodExtrasCategories: 'Food extras categories',
		foodExtraCategory: 'Food extra category',
		price: 'Price',
		category: 'Category',
		categories: 'Categories',
		incompleteRequiredFields: 'Incomplete required fields.',
		writeDescriptionHere: 'Write the description here',
		select: 'Select',
		foodExtraCategoryPopupMessage1: 'This is the list of food extras for the category.',
		foodExtraCategoryPopupMessage2: 'Products to which this category will be assigned.',
		favorite: 'Favorite',
		duplicate: 'Duplicate',
		recommendation: 'Recommendation',
		active: 'Active',
		briefDescription: 'Brief description',
		videoURL: 'Video URL',
		three60ImgURL: '360° image URL',
		size: 'Size',
		vat: 'VAT',
		images: 'Images',
		selectAll: 'Select all',
		writeHereThe: (fieldName, entity) => `Write here the ${fieldName?.toLowerCase()} of the ${entity?.toLowerCase()}.`,
		loading: 'Loading',
		screen: 'Screen',
		copyLinkToClipboard: 'Copy link to clipboard',
		qrCode: 'QR Code',
		services: 'Services',
		wifi: "Free Wi-Fi",
		outdoor_area: "Terrace or outdoor area",
		air_conditioned_area: "Air-conditioned area",
		online_reservations: "Online reservations",
		free_parking: "Free parking",
		valet_parking: "Valet parking",
		smoking_area: "Smoking area",
		live_music: "Live music",
		tv_screens: "Televisions / Screens",
		pet_friendly: "Pet-friendly",
		kids_menu: "Children's Menu",
		kids_play_area: "Children's play area",
		delivery_service: "Delivery service",
		takeaway: "Takeaway",
		card_payment: "Card payment",
		contactless_payment: "Contactless payment",
		device_charging: "Device charging",
		wheelchair_access: "Accessibility for people with disabilities",
		private_events: "Private events",
		vip_room: "VIP Room",
		happy_hour: "Happy hour",
		sommelier_service: "Sommelier service",
		wine_bar: "Wine bar",
		bar_area: "Bar area",
		rooftop: "Rooftop",
		dance_floor: "Dance floor",
		resident_dj: "Resident DJ",
		security_access_control: "Security and access control",
		vip_table_reservation: "VIP table reservations",
		coat_check: "Coat check",
		sports_screens: "Sports screens",
		craft_cocktails: "Craft cocktails",
		cigar_lounge: "Cigar lounge",
		cover_charge: "Cover charge",
		bottle_service: "Bottle service",
		hourly_promotions: "Hourly promotions",
		photo_spot: "Photo spot",
		personal_trainers: "Personal trainers",
		group_classes: "Group classes",
		lockers: "Lockers",
		changing_rooms: "Changing rooms",
		showers: "Showers",
		sports_spa: "Spa or sports massages",
		sauna: "Sauna",
		steam_room: "Steam room",
		jacuzzi: "Jacuzzi",
		nutritionist: "Nutritionist",
		weight_area: "Weight area",
		cardio_area: "Cardio area",
		tracking_app: "Tracking app",
		supplement_store: "Supplement store",
		protein_bar: "Protein bar",
		rest_area: "Rest area",
		healthy_cafe: "Healthy Cafeteria",
		secured_parking: "Secure parking",
		inhouse_bar: "In-house bar",
		inhouse_restaurant: "In-house restaurant",
		live_shows: "Live shows",
		membership_rewards: "Membership rewards",
		atms: "ATMs",
		security_24h: "24-hour security",
		vip_rooms: "VIP rooms",
		sports_betting_area: "Sports betting area",
		slot_machines: "Slot machines",
		roulette: "Roulette",
		poker: "Póker",
		blackjack: "Blackjack",
		tournaments: "Tournaments",
		table_drink_service: "Table drink service",
		covered_parking: "Covered parking",
		mall_security: "Mall security",
		public_restrooms: "Public restrooms",
		food_court: "Food court",
		public_wifi: "Public Wi-Fi",
		cinema: "Cinema",
		kids_zone: "Kids zone",
		ev_charging: "Charging points for electric cars",
		green_areas: "Green areas",
		events_activities: "Events activities",
		information_desk: "Information desk",
		mall_lockers: "Mall lockers",
		anchor_store: "Anchor store",
		diaper_station: "Diaper station",
		pickup: 'Pickup',
		waiter: 'Waiter',
		trainer: 'Trainer',
		assistant: 'Assistant',
		payTicket: 'Pay ticket',
		imHere: "I'm here",
		reservation: 'Reservation',
		wallet: 'Wallet',
		seeMap: "See map",
		enterQrCodeManually: "Enter QR code manually",
		account: 'Account',
		needSupport: 'Need support?',
		article: (isPlural) => isPlural ? 'articles' : 'article',
		orderVerb: 'Order',
		editOrder: 'Edit order',
		addOrderNote: 'Add a note to your order (optional):',
		askComplaintSuggestion: 'Do you have any complaints or suggestion?',
		addToCart: 'Add to Cart',
		getDiscounts: 'To obtain discounts & promotions',
		signUpWith: "sign up with",
		searchPlaceHolder:'Search for companies or products',
		bars: 'Bars',
		restaurants: 'Restaurants',
		shoppingCenters: 'Shopping center',
		hotels: 'Hotels',
		gyms: 'Gyms',
		casinos: 'Casinos',
		events: 'Events',
		others: 'Others',
		recentSearches: 'Recent searches',
		recentlyVisit: 'Recently visited',
		recent: 'Recent',
		seeOrders: 'See orders',
		orderNo: 'Order No.',
		status: 'Status',
		totalPrice: 'Total price',
		rateUs: 'Rate us',
		orderDetails: 'Order details',
		notifications: 'Notifications',
		says: 'says:',
		all: 'All',
		unread: 'Unread',
		readAdjPlural: 'Read',
		readAdjSingular: 'Read',
		noRecordsTxt: 'There are no records',
		filters: 'Filters',
		inactive: 'Inactive',
		inProcess: 'In process',
		confirmed: 'Confirmed',
		rejected: 'Rejected',
		date: 'Date',
		time: 'Time',
		numberOfPerson: 'Number of person',
		comments: 'Comments',
		today: 'Today',
		tomorrow: 'Tomorrow',
		week: 'Week',
		canceled: 'Canceled',
		requestAssistantHelp: 'Request assistant help',
		optionalComment: 'Comment (optional)',
		requestBill: 'Request the bill',
		rateService: 'Rate the service',
		clientRequestPayBill: 'The customer requestd to pay the bill',
		rateTheServiceOf: 'Rate the service of',
		writeComment: 'Escribe tu comentario aquí',
		paymentMethod: 'Payment method',
		selectMethod: 'Select a method',
		payInCash: 'Pay in cash',
		payBycard: 'Pay by card',
		cash: 'Cash',
		enterValidCode: 'Enter a valid code.',
		transfer: 'Transfer',
		selectEntityFrom: 'Select an entity from',
		listOf: 'List of',
		successfulTransfer: 'Successful transfer',
		errorTransfer: 'An error occurred while transferring the entities',
		confirmTransfer: 'Do you want to transfer the selected entities along with their assigned categories?',
		notTransferCategories: 'Do not transfer categories',
		swipeToRotate: 'Swipe the image to rotate',
		numberOfPeople: 'Number of people',
		reservationTime: 'Reservation time',
		availableTimes: 'Available times',
		selectedTimes: 'Selected times',
		partyLimitIs: 'The party limit is',
		acceptTimes: 'Accept times',
		selectMax: 'Select max',
		limitReached: (max) => `Limit reached: You can only select ${max} times per day`,
		allowInformationalPaymentByCard: 'Allow selection of cash or card, but only as a computer (simulated)',
		cardReader: '(card reader)',
		card: 'Card',
		imagesLimitSize: 'Images must be less than 15MB',
		productError: 'An error occurred while saving the product.',
		imagesLimitError: 'You cannot upload more than 4 images',
		formatNotAllowed: 'Format not allowed',
		fileTooLarge: (fileName) => `The file ${fileName} is too large (max 15MB)`,
	},
	es: {
		client: 'Cliente',
		company: 'Negocio',
		email: 'Correo Electrónico',
		password: 'Contraseña',
		email2: 'Correo electrónico ó teléfono',
		logIn: 'Iniciar Sesión',
		logOut: 'Cerrar Sesión',
		forgotPass: '¿Olvidaste tu contraseña?',
		noAccount: '¿No tienes cuenta?',
		createAccount: 'Crea una aquí',
		selectLanguage: 'Seleccionar Idioma',
		clientAccount: 'Crear cuenta de Cliente',
		businessAccount: 'Crear cuenta de Negocio',
		allSet: 'Ya tengo una cuenta',
		recoverPass: 'Recuperar contraseña',
		registration: 'Correo de registro',
		send: 'Enviar',
		recordClient: 'Registro de cliente',
		recordCompany: 'Registro de compañía',
		mandatoryField: 'Campo obligatorio',
		nameM: 'Nombre *',
		phoneM: 'Teléfono *',
		birthday: 'Fecha de nacimiento',
		minAge: 'El cliente debe tener al menos 18 años',
		emailM: 'Correo Electrónico*',
		passwordM: 'Contraseña*',
		confirmPassM: 'Repite la contraseña *',
		termsAndConditions: 'Aceptar los términos y condiciones -',
		see: 'Ver',
		acceptConditions: 'No se han aceptado los terminos y condiciones',
		accountCreated: '¿Ya tienes una cuenta?',
		companyNameM: 'Nombre de la compañía*',
		atentionC: 'Atención en Mostrador o Barra  (sin asistentes)',
		atentionR: 'Atención en Restaurante (con asistentes)',
		atentionFC: 'Atención en Plaza Comercial (con asistentes)',
		atentionE: 'Atención para eventos (con asistentes)',
		atentionHT: 'Atención para hostelería (con asistentes)',
		atentionH: 'Atención para hospitales (con asistentes)',
		atentionCM: 'Atención en Máquinas de Casino (con asistentes)',
		atentionG: "Atención en Gimnasio (con asistentes)",
		atentionO: "Otro - Venta de productos o servicios en general (sin asistentes)",
		numRooms: 'No. de habitaciones',
		numMachines: 'Número de máquinas',
		numStations: 'Número de estaciones',
		numAssistants: 'Número de asistentes',
		anniversary: 'Aniversario',
		ok: 'OK',
		selectMoney: 'Selecciona la Unidad Monetaria',
		registrateComp: 'Registrar compañía',
		invalidPass: 'La contraseña no coincide',
		invalidPhone: 'Teléfono no válido: Debe contener 10 dígitos',
		invalidEmail: 'Correo no válido: Formato incorrecto',
		registrate: 'Registrarse',
		cancel: 'Cancelar',
		atteType: 'Selecciona el tipo de atención',
		justSeeMenu: 'Solo ver el menú',
		menu: 'Menú',
		sendToAssistants: 'Enviar órdenes para el asistente',
		sendToKitchen: 'Enviar órdenes directamente a la cocina',
		accessType: 'Selecciona el tipo de acceso para clientes',
		close: 'Cerrar',
		terms_condi_ruf: 'Términos y Condiciones de Ruf',
		responsability: 'Descargo de Responsabilidad:',
		responsabilityTxt1: `Los términos 'nosotros' o 'nuestro' se refieren a Ruf.Tenga en cuenta que nuestros Términos y Condiciones pueden cambiar sin previo aviso. Al utilizar nuestro sitio o realizar un pedido, usted acepta los términos a continuación. En la medida permitida por la ley, renunciamos a toda responsabilidad por cualquier inconveniente derivado del uso de nuestro sitio y sistema.`,
		changes: 'Cambios en Pedidos:',
		changesTxt1: `Si hay algún cambio en su pedido, le informaremos y procederemos a comunicarnos con la compañía para realizar un reembolso en caso de cancelación. No asumimos responsabilidad por cualquier daño derivado de esta práctica.`,
		cancelPolitics: 'Política de Cancelación:',
		cancelPoliticsTxt: `Si desea cancelar un pedido, notifíquenoslo inmediatamente. La cancelación queda a nuestro criterio y el de la compañía donde utilice esta plataforma. Si la comida aún no está preparada, generalmente permitiremos la cancelación y proporcionaremos un reembolso. Una vez que se ha realizado el pedido, no se podrá cancelar.`,
		alcohol: 'Servicio de Alcohol:',
		alcoholTxt: `Operamos como un lugar con licencia para la venta de alcohol y cumplimos todas las leyes locales al respecto. No servimos alcohol a menores de 18 años.`,
		payments: 'Pagos:',
		paymentsTxt: `Actualmente, no aceptamos pagos, pero cuando lo hagamos, se procesarán de forma segura.`,
		taxes: 'Impuestos:',
		taxesTxt: `Nuestros precios incluyen impuestos, variando según la compañía. La tasa suele ser del 8% en zonas fronterizas y del 16% en el interior de México.`,
		rights: 'Derechos de Autor:',
		rightsTxt: `Todas las imágenes y contenido del sitio tienen derechos de autor y licencia. No deben distribuirse, modificarse ni utilizarse sin nuestro consentimiento previo, que puede negarse a nuestra discreción. El sitio puede imprimirse, pero no modificarse ni utilizarse con fines comerciales.`,
		webSite: 'Sitio Web:',
		webSiteTxt: `Al utilizar nuestro sitio web, acepta nuestros términos y condiciones. Nos esforzamos por garantizar la precisión de la información, pero no asumimos responsabilidad por daños derivados de información incorrecta o problemas de rendimiento. Utilizamos contenido de terceros en nuestro sitio.`,
		privacy: 'Privacidad:',
		privacyTxt: `Su privacidad es fundamental. Solicitamos información solo en el registro de la plataforma o si usted asiste a compañías que utilizan nuestro servicio, el aplicativo comparte su información solo con la compañías que usted visita, pero no comparte sus datos con lugares donde no es utilizada nuestra plataforma, dicho esto usted tendrá el consentimiento sobre cómo funciona esta aplicación, puede estar seguro que cuidaremos y resguardaremos su información. En los casos donde el registro es por la parte de la o compañía no utilizaremos su información más que para comunicarnos con usted o hacerle saber información importante, pero no compartiremos su información con nadie.`,
		contacts: 'Contactos',
		contact: 'Contacto',
		offices: 'Oficinas',
		support: 'Soporte',
		sales: 'Ventas',
		admin: 'Administración',
		mail: 'Correos',
		webPage: 'Página web',
		productSelectedInStationFormScreen: 'El producto seleccionado será mostrado al escanear el código QR generado.',
		updateItemsMessage: (entities) => `Los ${entities} se actualizaron correctamente.`,
		stalls: 'Puestos',
		stall: 'Puesto',
		save: 'Guardar',
		cancel: 'Cancelar',
		new: 'Nuevo',
		cleanFilters: 'Limpiar Fltros',
		actions: 'Acciones',
		order: 'Orden',
		name: 'Nombre',
		phone: 'Teléfono',
		typeOfClientAccess: 'Tipo de acceso al cliente',
		delete: 'Borrar',
		typeOfAttention: 'Tipo de atención',
		placeHolder: (entity) => `Escribe ${entity[entity.length-1]=='a'?'la':'el'} ${entity?.toLowerCase()} aquí.`,
		numAssistant: 'Número de asistentes',
		attachLogo: 'Adjuntar logo',
		attachCoverImage: 'Adjuntar imagen de portada',
		attachMapImage: 'Adjuntar imagen del mapa',
		attachImage: 'Adjuntar imagen',
		stations: 'Estaciones',
		import: 'Importar',
		code: 'Código',
		edit: 'Editar',
		exportToCSV: 'Exportar a CSV',
		printQRs: 'Imprimir códigos QR',
		importFile: 'Importar Archivo',
		importEntity: (entity) => `Importar ${entity}`,
		exportFile: 'Exportar archivo',
		filterByErrors: 'Filtrar por errores',
		verify: 'Verificar',
		saveTheRecord: 'Por favor, guarde primero el registro',
		cannotBeEmpty: 'No puede ser vacío.',
		hideCompanyLabel: 'Ocultar súper compañía',
		hideCompanyInfo: 'Ocultar súper compañía en el menú de puestos',
		parameters: 'Parámetros',
		recommendedProduct: 'Producto recomendado',
		sendNotificationAfter: 'Enviar notificación después de... (HH:mm)',
		notificationSettings: 'Configuración de notificaciones',
		serviceRating: 'Calificación del servicio',
		recomendationInfo: 'Recomendar los siguientes productos cada vez que compre',
		notifyClient: 'Notificar cliente',
		accessVisible: "Menu de Accesos Visible",
		sendToAssistant: "Enviar órdenes al asistente",
		wirelessNetworkName: 'Nombre de la red inalámbrica',
		wirelessNetworkPassword: 'Contraseña de la red inalámbrica',
		downloadQrCode: 'Descargar código QR',
		products: 'Productos',
		product: 'Producto',
		seeProducts: 'Ver Productos',
		companies: 'Compañias',
		callAssistant: 'Llamar a asistente',
		statusOfOrder: 'Estatus de Orden',
		offersAndWallet: 'Ofertas y Monedero',
		scanQR: 'Escanear QR',
		listOfCompatibleCompanies: 'Lista de empresas compatibles',
		hello: 'Hola',
		guest: 'Invitado',
		pressTheButtonToScan: 'Presiona el botón para escanear',
		captureCode:'Captura el código del QR',
		search: 'Buscar',
		searchAndSelectFoodExt: 'Buscar y seleccionar complementos',
		searchProducts: 'Buscar productos',
		enterTheCode: 'Ingrese el código',
		companyName: 'Nombre de la compañía',
		stationName: 'Nombre de la estación',
		rate:"Calificar",
		skip: "Saltar",
		bad:"Muy malo",
		notGood:"Malo",
		good:"Regular",
		veryGood:"Bueno",
		excellent:"Excelente",
		enableAppPermissions: 'Habilita los permisos de la app en Configuración de Clientes',
		loginSettings: 'Configuración de inicio de sesión',
		hideEmail: 'Ocultar correo electrónico',
		notProvided: 'No proporcionado',
		welcomeTo: 'Bienvenido a',
		seeMenu: 'Ver Menú',
		branch_offices: 'Sucursales',
		reservations: 'Reservaciones',
		communications: 'Comunicados',
		watch_orders: 'Ver Pedidos',
		connect_to_wifi: 'Conectar a Wifi',
		assistant: 'Asistencia',
		security: 'Seguridad',
		usernameLabel: 'Usuario',
		passwordLabel: 'Contraseña',
		loginButton: 'Iniciar Sesión',
		forgotPassword: '¿Olvidó su Contraseña?',
		languagePlaceholder: 'Seleccione un idioma.',
		spanish: 'Español',
		english: 'English',
		portuguese: 'Português',
		arabic: 'عرب',
		clientButton: 'Cliente',
		title: 'Ruf: Explora, pide y recoge',
		welcomeText: 'Mejorando la experiencia del cliente',
		descriptionText: 'Rastreo y monitoreo de vehículos',
		description: 'Descripción',
		mandatory: 'Obligatorio',
		selectorType: 'Tipo de selector',
		single: 'Única',
		multiple: 'Múltiple',
		quantity: 'Cantidad',
		foodExtras: 'Complementos',
		foodExtrasCategories: 'Categorías de complementos',
		foodExtraCategory: 'Categoría de complemento',
		price: 'Precio',
		category: 'Categoria',
		categories: 'Categorías',
		incompleteRequiredFields: 'Campos obligatorios incompletos.',
		writeDescriptionHere: 'Escribe la descripción aquí',
		select: 'Seleccionar',
		foodExtraCategoryPopupMessage1: 'Este es el listado de complementos de la categoría.',
		foodExtraCategoryPopupMessage2: 'Productos a los que se asignará esta categoría.',
		favorite: 'Favorito',
		duplicate: 'Duplicar',
		recommendation: 'Recomendación',
		active: 'Activo',
		briefDescription: 'Descripción breve',
		videoURL: 'URL del video',
		three60ImgURL: 'URL de la imagen 360°',
		size: 'Tamaño',
		vat: 'IVA',
		images: 'Imágenes',
		selectAll: 'Seleccionar Todos',
		writeHereThe: (fieldName, entity) => `Escribe aquí el ${fieldName?.toLowerCase()} del ${entity?.toLowerCase()}.`,
		loading: 'Cargando',
		screen: 'Pantalla',
		copyLinkToClipboard: 'Copiar enlace al portapapeles',
		qrCode: 'Código QR',
		services: 'Servicios',
		wifi: "Wi-Fi gratuito",
		outdoor_area: "Terraza o área al aire libre",
		air_conditioned_area: "Área climatizada",
		online_reservations: "Reservaciones en línea",
		free_parking: "Estacionamiento gratuito",
		valet_parking: "Valet parking",
		smoking_area: "Área para fumadores",
		live_music: "Música en vivo",
		tv_screens: "Televisores / Pantallas",
		pet_friendly: "Pet-friendly",
		kids_menu: "Menú infantil",
		kids_play_area: "Área de juegos para niños",
		delivery_service: "Servicio a domicilio",
		takeaway: "Para llevar",
		card_payment: "Pago con tarjeta",
		contactless_payment: "Pago sin contacto",
		device_charging: "Carga de dispositivos",
		wheelchair_access: "Accesibilidad para personas con discapacidad",
		private_events: "Eventos privados",
		vip_room: "Salón VIP",
		happy_hour: "Happy hour",
		sommelier_service: "Servicio de sommelier",
		wine_bar: "Cava o barra de vinos",
		bar_area: "Zona de bar",
		rooftop: "Rooftop",
		dance_floor: "Pista de baile",
		resident_dj: "DJ residente",
		security_access_control: "Seguridad y control de acceso",
		vip_table_reservation: "Reservación de mesas VIP",
		coat_check: "Guardarropa",
		sports_screens: "Pantallas para deportes",
		craft_cocktails: "Coctelería artesanal",
		cigar_lounge: "Salón de fumadores",
		cover_charge: "Cobro por cover",
		bottle_service: "Servicio de botellas",
		hourly_promotions: "Promociones por hora",
		photo_spot: "Fotografía o spot para redes",
		personal_trainers: "Entrenadores personales",
		group_classes: "Clases grupales",
		lockers: "Lockers",
		changing_rooms: "Vestidores",
		showers: "Regaderas",
		sports_spa: "Spa o masajes deportivos",
		sauna: "Sauna",
		steam_room: "Vapor",
		jacuzzi: "Jacuzzi",
		nutritionist: "Nutriólogo",
		weight_area: "Área de pesas",
		cardio_area: "Área cardiovascular",
		tracking_app: "App para seguimiento",
		supplement_store: "Tienda de suplementos",
		protein_bar: "Bar de proteína",
		rest_area: "Área de descanso",
		healthy_cafe: "Cafetería saludable",
		secured_parking: "Estacionamiento vigilado",
		inhouse_bar: "Bar interno",
		inhouse_restaurant: "Restaurante interno",
		live_shows: "Shows en vivo",
		membership_rewards: "Membresías o recompensas",
		atms: "Cajeros automáticos",
		security_24h: "Seguridad 24 horas",
		vip_rooms: "Salas VIP",
		sports_betting_area: "Área de apuestas deportivas",
		slot_machines: "Zona de máquinas",
		roulette: "Ruleta",
		poker: "Póker",
		blackjack: "Blackjack",
		tournaments: "Torneos",
		table_drink_service: "Servicio de bebidas en mesa",
		covered_parking: "Estacionamiento techado",
		mall_security: "Seguridad y vigilancia",
		public_restrooms: "Baños públicos",
		food_court: "Área de comida",
		public_wifi: "Wi-Fi público",
		cinema: "Cine",
		kids_zone: "Área infantil",
		ev_charging: "Puntos de carga para autos eléctricos",
		green_areas: "Áreas verdes",
		events_activities: "Eventos y actividades",
		information_desk: "Servicio de información",
		mall_lockers: "Lockers en plaza",
		anchor_store: "Tienda ancla",
		diaper_station: "Estación de pañales",
		pickup: 'Recoger',
		waiter: 'Mesero',
		trainer: 'Entrenador',
		payTicket: 'Pagar boleto',
		imHere: 'Ya llegué',
		reservation: 'Reservación',
		wallet: 'Monedero',
		seeMap: "Ver mapa",
		enterQrCodeManually: "Ingresar código QR manualmente",
		account: 'Cuenta',
		needSupport: '¿Necesitas soporte?',
		article: (isPlural) => isPlural ? 'artículos' : 'artículo',
		orderVerb: 'Ordenar',
		editOrder: 'Editar orden',
		addOrderNote: 'Añadir una nota a su orden (opcional):',
		askComplaintSuggestion: '¿Tiene alguna queja o sugerencia?',
		addToCart: 'Agregar',
		getDiscounts: 'Para continuar obteniendo\ndescuentos y promociones',
		signUpWith: "registrarse con",
		searchPlaceHolder:'Buscar compañías o productos',
		bars: 'Bares',
		restaurants: 'Restaurantes',
		shoppingCenters: 'Plazas',
		hotels: 'Hoteles',
		gyms: 'Gyms',
		casinos: 'Casinos',
		events: 'Eventos',
		others: 'Otros',
		recentSearches: 'Búsquedas recientes',
		recentlyVisit: 'Visitaste recientemente',
		recent: 'Recientes',
		seeOrders: 'Ver pedidos',
		orderNo: 'Num. orden',
		status: 'Estado',
		totalPrice: 'Precio Total',
		rateUs: 'Califícanos',
		orderDetails: 'Detalles de la orden',
		notifications: 'Notificaciones',
		says: 'dice:',
		all: 'Todas',
		unread: 'Sin leer',
		readAdjPlural: 'Leídas',
		readAdjSingular: 'Leido',
		noRecordsTxt: 'No hay registros',
		filters: 'Filtros',
		inactive: 'Inactivo',
		inProcess: 'En proceso',
		confirmed: 'Confirmada',
		rejected: 'Rechazada',
		date: 'Fecha',
		time: 'Hora',
		numberOfPerson: 'Cantidad de personas',
		comments: 'Comentarios',
		today: 'Hoy',
		tomorrow: 'Mañana',
		week: 'Semana',
		canceled: 'Cancelada',
		requestAssistantHelp: 'Solicitar ayuda de asistente',
		optionalComment: 'Comentario (opcional)',
		requestBill: 'Solicitar Cuenta',
		rateService: 'Calificar Servicio',
		clientRequestPayBill: 'Cliente solicita la cuenta',
		rateTheServiceOf: 'Califica el servicio de',
		writeComment: 'Escribe tu comentario aquí',
		paymentMethod: 'Método de pago',
		selectMethod: 'Selecciona un método',
		payInCash: 'Pagar en efectivo',
		payBycard: 'Pagar con tarjeta',
		cash: 'Efectivo',
		enterValidCode: 'Ingresa un código válido.',
		transfer: 'Traspasar',
		selectEntityFrom: 'Seleccione una entidad de',
		listOf: 'Lista de',
		successfulTransfer: 'Transferencia exitosa',
		errorTransfer: 'Ocurrió un error al transferir las entidades',
		confirmTransfer: '¿Desea traspasar las entidades seleccionadas junto con las categorias asignadas?',
		notTransferCategories: 'No transferir categorias',
		swipeToRotate: 'Desliza la imagen para girar',
		numberOfPeople: 'Cantidad de personas',
		reservationTime: 'Hora de reservación',
		availableTimes: 'Horarios disponibles',
		selectedTimes: 'Horarios seleccionados',
		partyLimitIs: 'El límite de personas es',
		acceptTimes: 'Aceptar horarios',
		selectMax: 'Selecciona máximo',
		limitReached: (max) => `Límite alcanzado: Solo puedes seleccionar ${max} horarios por día`,
		allowInformationalPaymentByCard: 'Permitir seleccionar efectivo o tarjeta pero solo como informático (simulado)',
		cardReader: '(Terminal)',
		card: 'Tarjeta',
		imagesLimitSize: 'Las imágenes deben pesar menos de 15 MB',
		productError: 'Se produjo un error al guardar el producto.',
		imagesLimitError: 'No se pueden subir más de 4 imágenes',
		formatNotAllowed: 'Formato no permitido',
		fileTooLarge: (fileName) => `El archivo ${fileName} es muy pesado (máx 15MB)`,
	},
	pt: {
		usernameLabel: 'Nome de usuário',
		passwordLabel: 'Senha',
		loginButton: 'Entrar',
		forgotPassword: 'Esqueceu sua senha?',
		languagePlaceholder: 'Selecione um idioma.',
		spanish: 'Español',
		english: 'English',
		portuguese: 'Português',
		arabic: 'عرب',
		clientButton: 'Cliente',
		title: 'Ruf: Explore, pergunte e colete',
		welcomeText: 'Melhorando a experiência do cliente',
		descriptionText: 'Rastreamento e monitoramento de veículos',
		support: 'Suporte',
	},
	ar: {
		usernameLabel: 'اسم المستخدم',
		passwordLabel: 'كلمة المرور',
		loginButton: 'تسجيل الدخول',
		forgotPassword: 'هل نسيت كلمة المرور؟',
		languagePlaceholder: 'اختر اللغة.',
		spanish: 'Español',
		english: 'English',
		portuguese: 'Português',
		arabic: 'عرب',
		clientButton: 'زبون',
		title: 'روف: استكشف واسأل واجمع',
		welcomeText: 'تحسين تجربة العملاء',
		descriptionText: 'تتبع المركبات ومراقبتها',
		support: 'الدعم الفني',
	},
}
